"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeThemeDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var string_1 = require("@devexpress/utils/lib/utils/string");
var destination_1 = require("../destination");
var office_theme_elements_destination_1 = require("./office-theme-elements-destination");
var OfficeThemeDestination = (function (_super) {
    tslib_1.__extends(OfficeThemeDestination, _super);
    function OfficeThemeDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OfficeThemeDestination.prototype, "elementHandlerTable", {
        get: function () {
            return OfficeThemeDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    OfficeThemeDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.name = this.data.readerHelper.readAttribute(reader, 'name');
                if (!string_1.StringUtils.isNullOrEmpty(this.name))
                    this.data.documentModel.colorProvider.officeTheme.name = this.name;
                return [2];
            });
        });
    };
    OfficeThemeDestination.handlerTable = new map_creator_1.MapCreator()
        .add('themeElements', function (data) { return new office_theme_elements_destination_1.OfficeThemeElementsDestination(data); })
        .get();
    return OfficeThemeDestination;
}(destination_1.ElementDestination));
exports.OfficeThemeDestination = OfficeThemeDestination;
